import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../../app/store";
import {SliceStatus} from "../../../BaseState";
import {BulkDeleteUrlsModalState} from "./BulkDeleteUrlsModalState";

const initialState: BulkDeleteUrlsModalState = {
  isOpened: false,
  pendings: [],
  status: SliceStatus.idle,
  error: null
};

export const bulkDeleteUrlsModalSlice = createSlice({
  name: "bulkDeleteUrlsModal",
  initialState,
  reducers: {
    setIsOpened: (draft, action: PayloadAction<boolean>) => {
      draft.isOpened = action.payload;
    }
  }
});

export const bulkDeleteUrlsModalState = (state: RootState): BulkDeleteUrlsModalState => state.bulkDeleteUrlsModal;
export const {setIsOpened} = bulkDeleteUrlsModalSlice.actions;
export default bulkDeleteUrlsModalSlice.reducer;
